const lessonTypes = {
    LESSON: 'core_lesson',
    FAST_TRACK_LESSON: 'core_fast_track_lesson',
    ANCILLARY_LESSON: 'core_ancillary_lesson',
    TWIG_COACH_LESSON: 'core_distance_learning_lesson',
};

export default lessonTypes;
